// DOP-925: quản lý anonymous_id / session_id / user_id cho Tracking SDK.
// anonymous_id: bền vững theo trình duyệt (localStorage).
// session_id: theo phiên, hết hạn sau 30 phút không hoạt động (sessionStorage).
import { storeRef } from "@/components/providers/StoreProvider"

const ANONYMOUS_ID_KEY = 'te_anonymous_id'
const SESSION_ID_KEY = 'te_session_id'
const SESSION_LAST_ACTIVE_KEY = 'te_session_last_active'
const SESSION_TIMEOUT_MS = 30 * 60 * 1000

const generateId = (): string => {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID()
  }
  // Fallback trình duyệt cũ / context không secure
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}-${Math.random().toString(36).slice(2, 10)}`
}

export const getAnonymousId = (): string => {
  let anonymousId = localStorage.getItem(ANONYMOUS_ID_KEY)
  if (!anonymousId) {
    anonymousId = generateId()
    localStorage.setItem(ANONYMOUS_ID_KEY, anonymousId)
  }
  return anonymousId
}

/**
 * Lấy session hiện tại, tự tạo mới nếu chưa có hoặc đã quá 30 phút không hoạt động.
 * Mỗi lần gọi sẽ chạm lại mốc hoạt động (giống GA session timeout).
 */
export const ensureSession = (): { sessionId: string, isNew: boolean } => {
  const now = Date.now()
  const lastActive = parseInt(sessionStorage.getItem(SESSION_LAST_ACTIVE_KEY) || '0')
  let sessionId = sessionStorage.getItem(SESSION_ID_KEY)
  const isNew = !sessionId || !lastActive || now - lastActive > SESSION_TIMEOUT_MS

  if (isNew) {
    sessionId = generateId()
    sessionStorage.setItem(SESSION_ID_KEY, sessionId)
  }
  sessionStorage.setItem(SESSION_LAST_ACTIVE_KEY, `${now}`)
  return { sessionId: sessionId as string, isNew }
}

/** user_id từ redux profile (null nếu chưa login) — đọc ngoài React qua storeRef. */
export const getUserId = (): string | null => {
  const profile: any = storeRef.current?.getState()?.user?.profile?.data
  if (profile?.customerCode) return `${profile.customerCode}`
  if (profile?.id != null) return `${profile.id}`
  return null
}

/** Device info gửi kèm session_start (spec mục Device Tracking — không dùng fingerprint lib). */
export const getDeviceProperties = (): Record<string, any> => {
  if (typeof navigator === 'undefined') return {}
  return {
    user_agent: navigator.userAgent,
    language: navigator.language,
    platform: navigator.platform,
    screen_width: window.screen?.width,
    screen_height: window.screen?.height,
    viewport_width: window.innerWidth,
    viewport_height: window.innerHeight,
    referrer: document.referrer || undefined,
  }
}
